import checkinApiReducer from "./checkinApiSlice";

export default checkinApiReducer;
export {
  checkinDocumentThunk,
  checkinDocumentsBulkThunk,
  clearCheckinError,
} from "./checkinApiSlice";
